import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { declareClientPackage, RuntimeDetails } from '@ClientBase/IClientPackage'
import { HandleReactComponentRendering } from '@ClientBase/React/RenderReactComponents'
import * as Video from '@ClientBase/Generic/VideoUtils'
import * as Animations from './Animations'
import * as Carousels from './Carousels'
import * as Home from './Home'
import * as JobTile from './Jobs/Tile'
import * as JobFilters from './Jobs/Filters'
import * as Modal from './Modal'
import * as Navigation from './Navigation'
import * as PostFilters from './Posts/Filters'
import * as SearchOverlay from './SearchOverlay'
import * as SocialProfile from './SocialProfileWidget'
import * as StickyApply from './StickyApply'
import SnippetAccordionReact from './Accordion/Accordion'
import SnippetStandardAccordionReact from './StandardAccordion/StandardAccordion'
import SnippetContent from './Content/Content'
import SnippetContentColumn from './ContentColumn/ContentColumn'
import SnippetIconsText from './IconsText/IconsText'
import SnippetImage from './Image/Image'
import SnippetImageContent from './ImageContent/ImageContent'
import SnippetHeading from './Heading/Heading'
import SnippetLinkBox from './LinkBox/LinkBox'
import SnippetSpacer from './Spacer/Spacer'
import SnippetVideo from './Video/Video'
import SnippetParagraph from './Paragraph/Paragraph'
import SnippetSingleLink from './SingleLink/SingleLink'
import SnippetStatistic from './Statistic/Statistic'
import SnippetBrandsCarousel from './BrandsCarousel/BrandsCarousel'
import SnippetSpotlights from './Spotlights/Spotlights'
import SnippetBenefit from './Benefit/Benefit'
import SnippetAnimatedCards from './AnimatedCards/AnimatedCards'
import SnippetLinkBoxCarousel from './LinkBoxCarousel/LinkBoxCarousel'

/**
 * Extend the ClientBase class so you can benefit from any event hooks that Attrax offers,
 * and so that Attrax knows you have defined specific methods
 */

const VIDEO_ROOT_CLASS = "page-job-details__banner-cta-video";

const _Components = {
    'SnippetAccordion': SnippetAccordionReact,
    'SnippetStandardAccordion': SnippetStandardAccordionReact,
    'SnippetContent': SnippetContent,
    'SnippetContentColumn': SnippetContentColumn,
    'SnippetIconsText': SnippetIconsText,
    'SnippetImage': SnippetImage,
    'SnippetImageContent': SnippetImageContent,
    'SnippetHeading': SnippetHeading,
    'SnippetLinkBox': SnippetLinkBox,
    'SnippetSpacer': SnippetSpacer,
    'SnippetVideo': SnippetVideo,
    'SnippetParagraph': SnippetParagraph,
    'SnippetSingleLink': SnippetSingleLink,
    'SnippetStatistic': SnippetStatistic,
    'SnippetBrandsCarousel': SnippetBrandsCarousel,
    'SnippetSpotlights': SnippetSpotlights,
    'SnippetBenefit': SnippetBenefit,
    'SnippetAnimatedCards': SnippetAnimatedCards,
    'SnippetLinkBoxCarousel': SnippetLinkBoxCarousel,
}

declareClientPackage({
    onCmsSnippetPreview() {
        HandleReactComponentRendering(React, ReactDOM, _Components)
    },
    onDocumentReady(details: RuntimeDetails) {
        HandleReactComponentRendering(React, ReactDOM, _Components)
        Home.initialise()
        Navigation.initialise()
        JobTile.initialise()
        JobFilters.initialise()
        PostFilters.initialise()
        Carousels.initialise()
        StickyApply.initialise()
        SocialProfile.initialise()
        SearchOverlay.initialise()
        Modal.initialise()
        Video.initVideoModals(VIDEO_ROOT_CLASS, true)
        $(document).on('job-filter-initialized', function () {
            (window as any).jobFilterNoReloadController.enableDefaultFilterCounts()
        })
        // Initialise animations on load
        /*
        window.addEventListener('load', () => {
            Animations.initialise()
        }) 
        */
    },
})